import React from 'react';
import { Form, FormGroup, Label, Input, Button, Col, Row, Card } from 'reactstrap';

const task = {
  images: [
    {
      src: 'https://picsum.photos/200/300',
      score: 0,
      id: ''
    },
    {
      src: 'https://picsum.photos/200/300',
      score: 0,
      id: ''
    },
    {
      src: 'https://picsum.photos/200/300',
      score: 0,
      id: ''
    },
    {
      src: 'https://picsum.photos/200/300',
      score: 0,
      id: ''
    },
    {
      src: 'https://picsum.photos/200/300',
      score: 0,
      id: ''
    },
  ],
  title: '',
  description: ''
}


export default () => {
  return <Col xs="12" className="py-5">


    <Row>

      {
        task.images.map((item, index) => {
          return (
            <Col xs="12" md="3">
              <Card className="p-2">

                <img src={item.src} />
                <span>Score: {item.score}</span>

                <Form inline>
                  <FormGroup inline>
                    <Label for="exampleSelect">Select score</Label>
                    <Input className="ml-2" size="sm" type="select" name="select" id="exampleSelect">
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                      <option>4</option>
                      <option>5</option>
                    </Input>
                  </FormGroup>
                  <FormGroup inline className="ml-1">
                    <Button size="sm">Save</Button>
                  </FormGroup>
                </Form>

              </Card>
            </Col>
          )
        })
      }

    </Row>

  </Col>
}
